'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

// Last-resort boundary for errors thrown by the root layout itself: it replaces the whole
// document, so it renders its own <html> and stays dependency-free.
export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
    useEffect(() => {
        Sentry.captureException(error);
    }, [error]);

    return (
        <html lang="fr">
            <body style={{ fontFamily: 'sans-serif', textAlign: 'center', padding: '4rem 1rem' }}>
                <h1>Oups ! Une erreur est survenue</h1>
                <p>Rechargez la page ou revenez plus tard.</p>
                <p><a href="/">Tablatures-Harmonica</a></p>
                {error.digest && <p style={{ fontSize: '0.75rem', color: '#888' }}>ID: {error.digest}</p>}
            </body>
        </html>
    );
}
